import ScrollToHelper from '../../00_utilities/helpers/ScrollToHelper';
import GeneralHelper from '../../00_utilities/helpers/GeneralHelper';

class ToTop {
    constructor(elem) {
        this.toTopButton = elem;
        this.boundWindowScrollListener = this.toTopButtonFading.bind(this);
        this.throttledWindowScrollListener = GeneralHelper.throttle(this.boundWindowScrollListener, 450);
        this.toggleClass = 'to-top--visible';
    }

    init() {
        // show and hide button depending on scrolling direction
        window.addEventListener('scroll', this.throttledWindowScrollListener);

        // add scroll top on click
        this.toTopButton.addEventListener('click', () => {
            ScrollToHelper.scrollTo(document.body, 0);
        });
    }

    /**
     * Fade in or out main navigation depending on scroll position
     */
    toTopButtonFading() {
        const scrollTop = window.pageYOffset;
        const scrollingUp = scrollTop < this.initialScrollTop;
        const viewportHeight = window.innerHeight;
        this.initialScrollTop = scrollTop;

        // scrolling up and position farther down than 1 viewport height from the top
        if (scrollingUp && (scrollTop > viewportHeight)) {
            this.toTopButton.classList.add(this.toggleClass);
            return;
        }

        this.toTopButton.classList.remove(this.toggleClass);
    }
}

export default ToTop;
